import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DMP_ICON_PATHS, DmpIconName } from './icon-paths.constants';

/**
 * Central icon registry — wraps reference SVG path data for safe template binding.
 */
@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(private readonly sanitizer: DomSanitizer) {}

  /** All icon names defined in the reference file */
  readonly iconNames = Object.keys(DMP_ICON_PATHS) as DmpIconName[];

  hasIcon(name: string): name is DmpIconName {
    return name in DMP_ICON_PATHS;
  }

  getPath(name: DmpIconName): string {
    return DMP_ICON_PATHS[name] ?? '';
  }

  /** Trusted inner HTML for SVG child elements (path/rect/polyline) */
  getSafePath(name: DmpIconName): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.getPath(name));
  }
}
